import { render, staticRenderFns } from "./search.vue?vue&type=template&id=08d20708&"
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"
import style0 from "./search.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./search.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SearchBox: require('/home/gitlab-runner/builds/vgGd9s8g/0/evintra/nuxt/components/search/search-result-page/SearchBox.vue').default,CategoryTag: require('/home/gitlab-runner/builds/vgGd9s8g/0/evintra/nuxt/components/search/search-result-page/CategoryTag.vue').default,Companies: require('/home/gitlab-runner/builds/vgGd9s8g/0/evintra/nuxt/components/search/search-result-page/Companies.vue').default,RequestCard: require('/home/gitlab-runner/builds/vgGd9s8g/0/evintra/nuxt/components/search/search-result-page/RequestCard.vue').default,FavoriteCard: require('/home/gitlab-runner/builds/vgGd9s8g/0/evintra/nuxt/components/search/search-result-page/FavoriteCard.vue').default,Sponsored: require('/home/gitlab-runner/builds/vgGd9s8g/0/evintra/nuxt/components/search/search-result-page/Sponsored.vue').default,HostedPrograms: require('/home/gitlab-runner/builds/vgGd9s8g/0/evintra/nuxt/components/search/search-result-page/HostedPrograms.vue').default})
